<h2 class="h2">{{'Gift Box Service' | translate}}</h2>
@for (box of content().giftBoxing; track $index) {
<p class="lh-3 p-t-3 p-t-4-m p-t-4-s">{{box.copy}}</p>
}
<div class="center p-t-3 p-t-8-m p-t-6-s p-b">
    <img class="w-6 w-7-m w-8-s"
         [dfImage]="content().giftBoxingImage"
         [ratio]="'ratio-1-1'"
         alt="Gift Box Service">
</div>